import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/utils';

/**
 * LinkButton — Renderiza um <a> (React Router Link) estilizado como botão.
 * Suporta nativamente: Ctrl+Click, Cmd+Click, middle-click (nova aba).
 * Clique normal navega na mesma aba via React Router (SPA).
 */
export const LinkButton = React.forwardRef(({ to, className, children, variant, size, ...props }, ref) => {
  const baseStyles = 'inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 no-underline';

  const variants = {
    default: 'bg-neon-lime text-black hover:bg-neon-lime/80 font-bold',
    outline: 'border border-zinc-700 text-zinc-400 hover:text-neon-lime hover:border-neon-lime/30 bg-transparent',
    ghost: 'text-zinc-400 hover:text-white hover:bg-zinc-800/50',
    full: 'w-full bg-neon-lime text-black font-black uppercase py-3 rounded-lg hover:bg-neon-lime/80 transition-colors',
    secondary: 'w-full border border-zinc-700 text-white font-bold py-3 rounded-lg hover:bg-zinc-800 transition-colors',
  };

  const sizes = {
    default: 'h-10 px-4 py-2',
    sm: 'h-9 rounded-md px-3',
    lg: 'h-11 rounded-md px-8',
    icon: 'h-10 w-10',
  };

  return (
    <Link
      ref={ref}
      to={to}
      className={cn(
        baseStyles,
        variants[variant || 'default'],
        sizes[size || 'default'],
        className
      )}
      {...props}
    >
      {children}
    </Link>
  );
});

LinkButton.displayName = 'LinkButton';
